// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const support = {
  // venue-hire
  getVenueHire(page,search,sort) {
    return AuthService.get(`/customer-support/venue-hire?page=${page}` +
      `&search=${search}` +
      `&sort=${sort}`
    );
  },
  showVenueHire(id) {
    return AuthService.get(`/customer-support/venue-hire/${id}`);
  },
  createVenueHire(data) {
    return AuthService.post("/customer-support/venue-hire", data);
  },
  updateVenueHire(id, data) {
    return AuthService.put(`/customer-support/venue-hire/${id}`, data);
  },
  deleteVenueHire(id) {
    return AuthService.delete(`/customer-support/venue-hire/${id}`);
  },
  // contact
  getContact(page,sort,search) {
    return AuthService.get(`/customer-support/contact-branch?` +
      `page=${page}` +
      `&sort=${sort}` +
      `&search=${search}`
    );
  },
  showContact(id) {
    return AuthService.get(`/customer-support/contact-branch/${id}`);
  },
  createContact(data) {
    return AuthService.post("/customer-support/contact-branch", data);
  },
  updateContact(id, data) {
    return AuthService.put(`/customer-support/contact-branch/${id}`, data);
  },
  deleteContact(id) {
    return AuthService.delete(`/customer-support/contact-branch/${id}`);
  },
  // group-visit
  getGroupVisit(page,search,sort) {
    return AuthService.get(`/customer-support/group-visit?`+
      `page=${page}` +
      `&sort=${sort}` +
      `&search=${search}`);
  },
  showGroupVisit(id) {
    return AuthService.get(`/customer-support/group-visit/${id}`);
  },
  createGroupVisit(data) {
    return AuthService.post("/customer-support/group-visit", data);
  },
  updateGroupVisit(id, data) {
    return AuthService.put(`/customer-support/group-visit/${id}`, data);
  },
  deleteGroupVisit(id) {
    return AuthService.delete(`/customer-support/group-visit/${id}`);
  },
  getSubScribe(page,start_date,end_date,sort) {
    return AuthService.get(`/customer-support/subscribes?page=${page}` +
      `&start_date=${start_date}` +
      `&end_date=${end_date}` +
      `&sort=${sort}`
    );
  },
  getEnewsletterCategories() {
    return AuthService.get(`/customer-support/newsletter-category-all`);
  },
  getEnewsletterCategoryById(id) {
    return AuthService.get(`/customer-support/newsletter-category-by-id/`+id);
  },
  deleteEnewsletterCategoryById(id) {
    return AuthService.delete(`/customer-support/newsletter-category/`+id);
  },
  storeEnewsletterCategory(payload) {
    return AuthService.post(`/customer-support/newsletter-category/`, payload);
  },
  editEnewsletterCategory(payload) {
    return AuthService.put(`/customer-support/newsletter-category/`+payload.id, payload);
  },
  getEnewsletterSubscribe(payload) {
    return AuthService.get(`/customer-support/subscribes/`, { params: payload });
  }

};
export default support;
